/*
溯源api
*/
import request from '@/utils/comm/request'
import configUrls from '@/config/urls'

export function login(data={}){
    return request({
        method: 'post',
        showLoading: false,
        url:configUrls.getBaseUrl()+'/mall/login',
        data: data
        // params:{
        //     tracing_code: data.code || localStorage.code
        // }
    })
}

// 腾讯云短信验证码
export function smsSender(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/smsSender',
    data: data
  })
}

// 微信登录
export function wxLogin(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/wxLogin',
    data: data
  })
}

// 关注的品牌动态
export function findUserAttentionBrandTrends(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/account/findUserAttentionBrandTrends',
    data: data
  })
}

// 增加|修改收货地址
export function createAccountAddress(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/account/createAccountAddress',
    data: data
  })
}

// /mall/account/findAccountAddressByAddressId
// 查询收货地址
export function findAccountAddressByAddressId(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/account/findAccountAddressByAddressId',
    data: data
  })
}

// 删除收货地址
export function deleteAccountAddress(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/account/deleteAccountAddress',
    data: data
  })
}

// 切换默认地址
export function switchDefaultAccountAddress(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/account/switchDefaultAccountAddress',
    data: data
  })
}

// 省市区
export function findDistrict(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/findDistrict',
    data: data
  })
}

// 收货地址列表
export function findAccountAddressListByAccountId(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/account/findAccountAddressListByAccountId',
    data: data
  })
}

export function getDistrict(data={}){
  return request({
    method: 'get',
    url:'/admin/brand/getDistrict',
  })
}

// https://user-test.vatrue.com/mall/findStoreByStoreId
//  查询商城
export function findStoreByStoreId(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/findStoreByStoreId',
    data: data
  })
}


// 门店商品分类列表
export function findStoreGoodsCategoryList(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/findStoreGoodsCategoryList',
    data: data
  })
}

// 商城商品列表
export function findStoreGoodsList(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/findStoreGoodsList',
    data: data
  })
}

// 获取门店下的全部商品
export function findStoreGoodsListByStoreId(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/findStoreGoodsListByStoreId',
    data: data
  })
}
// https://user-test.vatrue.com/mall/findStoreGoodsListByDirection
// 商品价格排序
export function findStoreGoodsListByDirection(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/findStoreGoodsListByDirection',
    data: data
  })
}

// /mall/searchStoreGoodsListByKeyword
// 商品搜索
export function searchStoreGoodsListByKeyword(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/searchStoreGoodsListByKeyword',
    data: data
  })
}

// 品牌详情及动态
export function findBrand(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/findBrand',
    data: data
  })
}

//
// 商品详情
export function findStoreGoods(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/findStoreGoods',
    data: data
  })
}


// 物品详情
export function findProductIntroduceListByProductId(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/findProductIntroduceListByProductId',
    data: data
  })
}

// 追溯事件类别
export function findBrandOriginListByBrandId(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/findProductTraceScopeByProductId',
    data: data
  })
}

// 追溯事件类别
export function findProductTrace(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/findProductTrace',
    data: data
  })
}


// 商品评论
export function findOrderCommentList(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/findOrderCommentList',
    data: data
  })
}

//获取品牌动态列表
export function findBrandTrendList(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/findBrandTrendList',
    data: data
  })
}

// 获取品牌动态详情
export function findBrandTrendDetail(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/findBrandTrendDetail',
    data: data
  })
}

//获取品牌官方商城商品列表
export function findOfficialStoreGoodsList(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/findOfficialStoreGoodsList',
    data: data
  })
}


//创建加入购物车
export function createShoppingCart(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/createShoppingCart',
    data: data
  })
}

//购物车商品列表
export function findShoppingCartListByAccountId(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/findShoppingCartListByAccountId',
    data: data
  })
}

//购物车商品列表
export function findShoppingCartList(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/findShoppingCartList',
    data: data
  })
}

//关注门店
export function attentionStore(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/attentionStore',
    data: data
  })
}

// 关注品牌
export function attentionBrand(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/attentionBrand',
    data: data
  })
}

// 更改购物车商品数量
export function changeShoppingCartNum(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/changeShoppingCartNum',
    data: data
  })
}

// 清空购物车失效的商品
export function clearInvalidShoppingCart(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/clearInvalidShoppingCart',
    data: data
  })
}

// 批量关注商品
export function createBatchAttentionGoods(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/createBatchAttentionGoods',
    data: data
  })
}
// 更改购物车中商品规格
export function changeShoppingCartGoodsSpec(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/changeShoppingCartGoodsSpec',
    data: data
  })
}
// 删除购物车中的商品
export function deleteShoppingCartGoods(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/deleteShoppingCartGoods',
    data: data
  })
}

// 获取用户默认地址
export function findDefaultAccountAddress(data={}){
  return request({
    method: 'post',
    showLoading: false,
    doNotRepeat: true,
    url:configUrls.getBaseUrl()+'/mall/account/findDefaultAccountAddress',
    data: data
  })
}
//获取购物车中选中的商品
export function findSelectedGoodsList(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/findSelectedGoodsList',
    data: data
  })
}

//下单
export function createOrder(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/createOrder',
    data: data
  })
}

//全部订单列表
export function findOrders(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/findOrders',
    data: data
  })
}

//JSAPI支付
export function pay(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/pay',
    data: data
  })
}

// 支付宝手机网页支付
export function aliWapPay(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/aliWapPay',
    data: data
  })
}

//品牌动态评论
export function findBrandTrendByTrendId(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/findBrandTrendByTrendId',
    data: data
  })
}

//用户品牌动态收藏
export function createAccountBrandTrendFavorite(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/createAccountBrandTrendFavorite',
    data: data
  })
}

// 品牌动态点赞
export function createAttentionBrandTrend(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/createBrandTrendZambia',
    data: data
  })
}

// 品牌动态评论点赞
export function createBrandTrendCommentZambia(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/createBrandTrendCommentZambia',
    data: data
  })
}

// 品牌动态评论
export function createBrandTrendComment(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/createBrandTrendComment',
    data: data
  })
}

// 获取用户名片列表
export function findAccountCardList(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/findAccountCardList',
    data: data
  })
}

// 订单提醒发货
export function sendOrderNotice(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/sendOrderNotice',
    data: data
  })
}

//订单详情//
export function findOrderDetail(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/findOrderDetail',
    data: data
  })
}

// 更新收货地址
export function updateOrderAddress(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/updateOrderAddress',
    data: data
  })
}
// 删除订单
export function deleteOrderByOrderId(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/deleteOrderByOrderId',
    data: data
  })
}

// 获取物流信息
export function findOrderLogisticsInfo(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/findOrderLogisticsInfo',
    data: data
  })
}

// 获取融云用户信息
export function findRongCloudUser(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/findRongCloudUser',
    data: data
  })
}
// 融云聊天列表
export function findRongMessageList(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/findRongMessageList',
    data: data
  })
}

//融云聊天详情记录列表
export function findRongMessageDetailList(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/findRongMessageDetailList',
    data: data
  })
}

// 获取腾讯云临时秘钥
export function findTempKeys(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/findTempKeys',
    data: data
  })
}

// 申请退款/申请售后
export function createRefundOrder(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/createRefundOrder',
    data: data
  })
}

// 填写物流信息
export function createOrderAfterLogisticsInfo(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/createOrderAfterLogisticsInfo',
    data: data
  })
}

// 获取订单售后信息
export function findOrderAfterInfo(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/findOrderAfterInfo',
    data: data
  })
}

// /撤销退款申请
export function cancelRefundOrder(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/cancelRefundOrder',
    data: data
  })
}

// /取消订单/
export function cancelOrderByOrderId(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/cancelOrderByOrderId',
    data: data
  })
}

// 创建订单评论
export function createOrderComment(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/createOrderComment',
    data: data
  })
}

// 确认收货
export function finishOrder(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/finishOrder',
    data: data
  })
}

// 确认收货
export function findAttentionListByAccountId(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/findAttentionListByAccountId',
    data: data
  })
}
// 关注商品
export function createAttentionGoods(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/createAttentionGoods',
    data: data
  })
}

// 获取用户分享列表/
export function findAccountShareListByAccountId(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/findAccountShareListByAccountId',
    data: data
  })
}

// 获取名片详情
export function findCardInfo(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/findCardInfo',
    data: data
  })
}

// 获取用户收藏列表
export function findAccountFavoriteList(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/findAccountFavoriteList',
    data: data
  })
}

// 获取用户收藏列表
export function findLongDetailByLongId(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/findLongDetailByLongId',
    data: data
  })
}

// 品牌直播列表
export function findBrandLiveList(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/findBrandLiveList',
    data: data
  })
}

// 品牌监控列表
export function findMonitorList(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/mall/findMonitorList',
    data: data
  })
}

///  扫码历史
export function findScanHistories(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/miniApi/mini/account/findScanHistories',
    data: data
  })
}

// 唯一码信息
export function findUniqueIdInfo(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/miniApi/mini/findUniqueIdInfo',
    data: data
  })
}

// 溯源品牌信息
export function findBrandInfo(data={}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/miniApi/mini/findBrandInfo',
    data: data
  })
}

/**
 * 查看唯一码是否开启留言
 */
export function findUniqueIdIsOpenMessage(data = {}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/miniApi/mini/findUniqueIdIsOpenMessage',
    data: data
  })
}

/**
 * 查看唯一码是否开启留言
 */
export function findMessageList(data = {}){
  return request({
    method: 'post',
    showLoading: false,
    url:configUrls.getBaseUrl()+'/miniApi/mini/findMessageList',
    data: data
  })
}



























































// WEBPACK FOOTER //
// ./src/api/comm/index.js